import { FilePreview } from "./FilePreview";
import { FileGallery } from "./FileGallery"
import { FileTable } from "./FileTable"
import { Document, Property } from "types";
import { GridSortModel, GridFilterModel } from "@mui/x-data-grid-pro";
import { IndexableDocument } from "hooks/queries/useDocuments";
import { ReactNode } from "react";
import { WorkspaceConfig } from "types/WorkspaceConfig";

// TODO rename with DocumenntExplorer
export type FileExplorerProps = {
    displayView: "table" | "gallery",
    workspaceConfig: WorkspaceConfig,
    preview?: boolean,
    tileSize?: number,
    documents: IndexableDocument[],
    documentsCount: number,
    selection?: Document[],
    loading?: boolean,
    properties: Property[],
    pageSize: number,
    pageIndex: number,
    sortOrder: GridSortModel,
    enableTags?: boolean,
    onPageChange: (newPageIndex: number) => void,
    onFilterChange?: (newFilterModel: GridFilterModel) => void,
    onSortChange?: (newSortModel: GridSortModel) => void,
    previewComponent?: (item: any, control: ReactNode) => JSX.Element,
    onSelection?: (selection: Document[]) => void,
    onNameClick?: (file: Document) => void,
    onPreviewClick?: (file: Document) => void,
}

export function FileExplorer(props: FileExplorerProps) {

    const { preview, onPreviewClick } = props;

    if (props.displayView === "gallery")
        return <FileGallery {...props} />

    if (preview)
        return <FileTable
            {...props}
            previewComponent={
                (document: Document, control: JSX.Element) => <FilePreview
                    document={document}
                    onClick={() => onPreviewClick && onPreviewClick(document)}
                    previewToggleControl={control}
                />
            }

        />

    return <FileTable {...props} />
}
